// extracted by mini-css-extract-plugin
module.exports = {"box":"Artifact_box__2Ezbw","enchant":"Artifact_enchant__BGW2Z","img":"Artifact_img__36s9-"};